const employeeAllocation = {
	MANUAL: 'manual',
	MACHINE: 'machine'
};

export default employeeAllocation;